import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

export const taxStyles = `
.tss-page .page-title { color: #1f2937; }
.tss-heading { font-size: 1.15rem; font-weight: 700; margin-bottom: 4px; }
.tss-subtitle { color: #6b7280; font-size: 13px; margin-bottom: 16px; }
.tss-point {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: #fff;
  border-radius: 16px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
}
.tss-point-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
}
.tss-point h6 { margin: 0 0 2px; font-size: 14px; font-weight: 600; }
.tss-point p { margin: 0; color: #6b7280; font-size: 13px; line-height: 1.45; }
.tss-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 8px;
}
.tss-action {
  border: 0;
  border-radius: 14px;
  min-height: 72px;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 8px;
  text-align: center;
}
.tss-action:disabled { opacity: 0.7; }
.tss-action i { font-size: 18px; }
.tss-action-download { background: linear-gradient(135deg, #c0282c, #f59e0b); }
.tss-action-compare { background: linear-gradient(135deg, #2563eb, #06b6d4); }
.tss-action-email { background: linear-gradient(135deg, #c0282c, #2563eb); }
.tss-regime {
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 12px;
}
.tss-regime button {
  flex: 1;
  border: 0;
  background: transparent;
  border-radius: 999px;
  padding: 8px 10px;
  font-weight: 600;
  font-size: 13px;
  color: #6b7280;
}
.tss-regime button.active {
  background: #fff;
  color: #c0282c;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}
.tss-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #16a34a;
  margin-left: 6px;
}
.tss-banner {
  background: #e4f7e8;
  color: #16a34a;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 12px;
}
.tss-hero, .tss-section, .tss-card {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
}
.tss-hero-label { color: #6b7280; font-size: 13px; font-weight: 500; }
.tss-hero-value { font-size: 28px; font-weight: 700; margin: 4px 0 12px; }
.tss-hero-row { display: flex; justify-content: space-between; gap: 12px; color: #6b7280; font-size: 13px; }
.tss-hero-row strong { font-weight: 600; }
.tss-section-title, .tss-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 8px;
}
.tss-accent { width: 3px; height: 14px; border-radius: 2px; background: #c0282c; }
.tss-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  font-size: 13px;
}
.tss-row span { color: #6b7280; flex: 1.4; }
.tss-row strong { font-weight: 600; text-align: right; }
.tss-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #c0282c;
  color: #c0282c;
  background: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}
.tss-tabs {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 14px;
}
.tss-tabs button {
  border: 0;
  background: transparent;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
}
.tss-tabs button.active { background: #fff; color: #c0282c; box-shadow: 0 2px 8px rgba(15,23,42,0.08); }
.tss-summary {
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  gap: 12px;
  background: #fff;
  border-radius: 16px;
  border-top: 3px solid #c0282c;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
}
.tss-summary-caption { color: #6b7280; font-size: 12px; }
.tss-summary-value { font-size: 18px; font-weight: 700; }
.tss-summary-value em { color: #c0282c; font-style: normal; margin-right: 4px; }
.tss-stat-row { display: flex; gap: 12px; margin: 8px 0; }
.tss-stat-cell { flex: 1; }
.tss-stat-caption { color: #6b7280; font-size: 12px; }
.tss-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.tss-field label { color: #6b7280; font-size: 13px; margin: 0; flex: 1; }
.tss-currency {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px 10px;
  min-width: 140px;
}
.tss-currency span { color: #6b7280; margin-right: 4px; }
.tss-currency input, .tss-type-input {
  border: 0;
  background: transparent;
  width: 100%;
  text-align: right;
  outline: none;
  font-weight: 600;
}
.tss-type-input {
  background: #f3f4f6;
  border-radius: 10px;
  padding: 8px 10px;
  text-align: left;
  min-width: 180px;
}
.tss-chips { display: flex; gap: 6px; }
.tss-chips button {
  border: 0;
  border-radius: 999px;
  padding: 6px 14px;
  background: #f3f4f6;
  color: #6b7280;
  font-weight: 600;
  font-size: 12px;
}
.tss-chips button.active { background: #c0282c; color: #fff; }
.tss-bar {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}
.tss-empty {
  background: #f3f4f6;
  border-radius: 12px;
  text-align: center;
  color: #6b7280;
  padding: 18px 12px;
  font-size: 13px;
}
.tss-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 16px;
}
.tss-modal {
  width: min(420px, 100%);
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
}
@media (max-width: 768px) {
  .tss-actions, .tss-summary, .tss-field { grid-template-columns: 1fr; display: flex; flex-direction: column; }
  .tss-actions { display: grid; }
}
`;

const TaxPage: React.FC<{
  crumb?: string;
  children: React.ReactNode;
}> = ({ crumb, children }) => (
  <div className="page-wrapper tss-page">
    <style>{taxStyles}</style>
    <div className="content">
      <div className="page-header">
        <div className="page-title">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Tax Simplifier Statement</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.employeeDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Other Services</li>
                {crumb ? (
                  <>
                    <li className="breadcrumb-item">
                      <Link to={all_routes.taxSimplifier}>Tax Simplifier Statement</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {crumb}
                    </li>
                  </>
                ) : (
                  <li className="breadcrumb-item active" aria-current="page">
                    Tax Simplifier Statement
                  </li>
                )}
              </ol>
            </nav>
          </div>
        </div>
      </div>
      {children}
    </div>
  </div>
);

export default TaxPage;
